<template>
  <div>
    <el-image v-if="srcUrl" style="width: 100%; height: 100%" :src="srcUrl" :style='styleC' @click="onPreview(srcUrl)">
      <div slot="error" class="image-slot">
        <i class="el-icon-picture-outline"></i>
      </div>
    </el-image>
    <el-image-viewer v-if="showViewer" :on-close="closeViewer" :url-list="[showViewerUrl]" :zIndex="zIndex" />
  </div>
</template>

<script>
import ElImageViewer from "element-ui/packages/image/src/image-viewer";
export default {
  components: {
    ElImageViewer
  },
  data() {
    return {
      showViewer: false, // 显示查看器
      showViewerUrl: ""
    };
  },
  name: "",
  props: {
    srcUrl: {
      type: String,
      default: null
    },
    styleC: {
      type: String,
      default: null
    },
    zIndex: {
      type: Number,
      default: 9999
    }
  },
  computed: {},
  methods: {
    // 关闭查看器
    closeViewer() {
      this.showViewer = false;
    },
    //打开查看器
    onPreview(showViewerUrl) {
      this.showViewerUrl = showViewerUrl;
      this.showViewer = true;
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/PreviewImage.vue